module.exports = __webpack_public_path__ + "img/icon_tools.b82ed080.png";